<template>
<div class='mini-sched-container'>
  <div class='timeline'>
    <div v-for='t in tickTimeStrings' class='tick'>
      <span class='spacer'></span>
      <span class='label'>{{t}}</span>
      <span class='spacer'></span>
    </div>
  </div>
  <div>
    <div class='mini-sched-header'>
      <div v-for='d in dateStrings' :key='d'>{{d}}</div>
    </div>
    <div class='mini-sched-body'>
      <div v-for='d in visibleDates' class='column'>
        <div>
        <div v-for='room in visibleRooms' :key='room.id'>{{room.name}}</div>
        </div>
        <div>
          <div v-for='room in visibleRooms' :key='room.id' class='track'>
            <div v-for='t in tickTimes' class='tick'>
              <div
                v-for='period in periods'
                :class="[calcPeriodPosition(period, t)]"
                :style="{'height': calcPeriodHeight(period, t)+'%'}"
                :key='period.name'
                v-if='periodBelongs(period, d, room, t)'
                class='period'
              >
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { DateTime, Interval } from "luxon";
export default {
  props: {
    periods: {
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      event: null,
      tickIntervalSeconds: 60 * 60
    };
  },
  computed: {
    dates: function() {
      let result = [];
      if (this.event) {
        let s = this.event.start;
        while (s <= this.event.end) {
          result.push(s);
          s = s.plus({ days: 1 });
        }
      }
      return result;
    },
    visibleDates: function() {
      return this.dates.filter(d => {
        for (let i = 0; i < this.periods.length; i++) {
          const period = this.periods[i];
          if (period.start.hasSame(d, "day")) {
            return true;
          }
          if (period.end.hasSame(d, "day")) {
            return true;
          } else {
            return false;
          }
        }
      });
    },
    rooms: function() {
      return this.event.details.rooms;
    },
    visibleRooms: function() {
      let roomPeriodIds = this.periods.map(p => p.room);
      return this.rooms.filter(r => roomPeriodIds.indexOf(r.id) !== -1);
    },
    dateStrings: function() {
      return this.visibleDates.map(d => d.toFormat("DD"));
    },
    tickTimes: function() {
      let result = [];
      let s = this.event.start;
      let e = this.event.start.endOf("day");
      while (s <= e) {
        result.push(s);
        s = s.plus({ seconds: this.tickIntervalSeconds });
      }
      return result;
    },
    tickTimeStrings: function() {
      return this.tickTimes.map(t => t.toLocaleString(DateTime.TIME_SIMPLE));
    }
  },
  methods: {
    periodBelongs(period, date, room, tick) {
      let tickRange = Interval.fromDateTimes(
        tick,
        tick.plus({ seconds: this.tickIntervalSeconds })
      );
      let periodRange = Interval.fromDateTimes(period.start, period.end);
      return (
        period.start.hasSame(date, "day") &&
        period.room == room.id &&
        tickRange.overlaps(periodRange)
      );
    },
    calcPeriodPosition: function(period, tick) {
      let tickRange = Interval.fromDateTimes(
        tick,
        tick.plus({ seconds: this.tickIntervalSeconds })
      );
      let periodRange = Interval.fromDateTimes(period.start, period.end);
      if (periodRange.start <= tickRange.start) {
        return "top";
      } else if (periodRange.end >= tickRange.end) {
        return "bottom";
      } else {
        return "middle";
      }
    },
    calcPeriodHeight: function(period, tick) {
      let tickRange = Interval.fromDateTimes(
        tick,
        tick.plus({ seconds: this.tickIntervalSeconds })
      );
      let periodRange = Interval.fromDateTimes(period.start, period.end);
      let overlap = tickRange.intersection(periodRange).length("seconds");

      let heightPercent = overlap / this.tickIntervalSeconds;
      return heightPercent > 1 ? 100 : heightPercent * 100;
    }
  },
  beforeMount: function() {
    this.event = this.$store.getters.event();
  }
};
</script>

<style scoped lang='scss'>
.mini-sched-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 250px;
  overflow-y: auto;
  > div:last-child {
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
    > div:last-child {
      flex: 1 0 0;
    }
  }
}
.timeline {
  margin-top: 51px;
  font-size: 0.5rem;
  width: 50px;
  flex-shrink: 0;
}
.tick {
  height: 20px;
  display: flex;
  align-items: flex-start;
  line-height: 0px;

  .label {
    margin: 0px 4px;
  }
  .spacer {
    background: $gray-4;
    height: 1px;
    flex-grow: 1;
  }
}
.mini-sched-header {
  display: flex;
  height: 30px;
  flex-shrink: 0;
  flex-grow: 0;
  > div {
    min-width: 100px;
    font-size: 0.8rem;
    border: 1px solid $gray-4;
    text-align: center;
    flex: 1 0 0;
  }
}
.mini-sched-body {
  display: flex;
  > div {
    flex: 1 0 0;
    border: 1px solid $gray-4;
    text-align: center;
  }
}
.column {
  display: flex;
  flex-direction: column;
}
.column > div:first-child {
  display: flex;
  height: 20px;
  flex-shrink: 0;
  flex-grow: 0;
  font-size: 0.7rem;
  > div {
    flex: 1 0 0;
    min-width: 100px;
  }
}
.column > div:last-child {
  flex: 1 0 0;
  display: flex;
}
.track {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  border-top: 1px solid $gray-4;
}
.track:not(:first-child) {
  border-left: 1px dotted $gray-4;
}
.period {
  width: 100%;
  background: $primary;
}
.period.bottom {
  align-self: flex-end;
}
.period.top {
  align-self: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/event/miniScheduler.vue